<div *ngIf="isLoading" class="overlay">
  <div class="spinner"></div>
</div>
<div class="container-fluid py-4">
    <div class="card">
      <div class="card-header">
        <h3 class="text-center">Items</h3>
        <div class="card-tools">
          <a
            [routerLink]="['/billing/invoices/items/add']"
            class="btn btn-dark btn-sm btn-new"
          >
            New item
          </a>
          <a
            [routerLink]="['/billing/invoices']"
            class="btn btn-dark btn-sm btn-new"
          > back
          </a>
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Rate</th>
                <th>Unit of use</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of data">
                <td>{{ item.item_name }}</td>
                <td>{{ item.description }}</td>
                <td>{{ item.rate }}</td>
                <td>{{ item.unit }}</td>
                <td>
                  <span
                    class="badge"
                    [ngClass]="item.status ? 'badge-success' : 'badge-danger'"
                  >
                    {{ item.status ? "Active" : "Inactive" }}
                  </span>
                </td>
                <td>{{ item.created_time_formatted }}</td>
                <td>
                  <a
                    [routerLink]="['/billing/invoices/items/edit', item.item_id]"
                    class="btn btn-link text-dark btn-sm btn-del"
                  >
                    <i class="fas fa-edit"></i>
                  </a>
                  <button
                    (click)="deleteData(item.item_id)"
                    class="btn btn-link text-dark btn-sm btn-del"
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  